import { render, staticRenderFns } from "./content.vue?vue&type=template&id=381ec03d&scoped=true&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"
import style0 from "./content.vue?vue&type=style&index=0&id=381ec03d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!//node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381ec03d",
  null
  
)

export default component.exports